import { PropsWithChildren, ReactElement } from "react";

import { Divider } from "antd";

import { HeaderContainer, Container, FilterContainer } from "./styles";
import HeaderInfo from "./HeaderInfo";

type PageHeaderProps = {
  id?: string;
  avatar: any;
  title: string | ReactElement;
  avatarStyle?: any;
  navigateTo?: ReactElement;
};

function PageHeader({
  children,
  id,
  avatar,
  title,
  navigateTo,
  avatarStyle,
  ...props
}: PropsWithChildren<PageHeaderProps>) {
  return (
    <HeaderContainer>
      <Container id={id}>
        {navigateTo}
        <HeaderInfo Avatar={avatar} title={title} avatarStyle={avatarStyle || {}} />
      </Container>

      <FilterContainer>{children}</FilterContainer>

      <Divider />
    </HeaderContainer>
  );
}

export default PageHeader;
